<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar :sidebar-item-color="sidebarBackground" :sidebar-background-image="sidebarBackgroundImage">
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Inicio</p>
      </sidebar-link>

      <sidebar-link v-if="usuario && ['admin', 'usuario'].includes(usuario.rol)" to="/table">
        <md-icon>content_paste</md-icon>
        <p>Crear</p>
      </sidebar-link>

      <sidebar-link v-if="usuario && ['admin', 'usuario'].includes(usuario.rol)" to="/typography">
        <md-icon>library_books</md-icon>
        <p>Mostrar</p>
      </sidebar-link>

      <sidebar-link v-if="usuario && usuario.rol === 'admin'" to="/user">
        <md-icon>person</md-icon>
        <p>Crear Usuarios</p>
      </sidebar-link>

      <sidebar-link v-if="usuario && usuario.rol === 'admin'" to="/icons">
        <md-icon>bubble_chart</md-icon>
        <p>Administrar Usuarios</p>
      </sidebar-link>

      <sidebar-link v-if="usuario && usuario.rol === 'admin'" to="/manage">
        <md-icon>library_books</md-icon>
        <p>Administrar Costos</p>
      </sidebar-link>
      


      <sidebar-link :to="{ name: 'Login' }" @click.native.prevent="logout">
        <md-icon>exit_to_app</md-icon>
        <p>Cerrar Sesión</p>
      </sidebar-link>


    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <fixed-plugin :color.sync="sidebarBackground" :image.sync="sidebarBackgroundImage">
      </fixed-plugin>

      <dashboard-content> </dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import FixedPlugin from "./Extra/FixedPlugin.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
    FixedPlugin,
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),
      usuario: JSON.parse(localStorage.getItem("usuario")),
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("authToken");
      localStorage.removeItem("usuario");
      localStorage.removeItem("tokenExpiry");
      this.$router.replace({ name: "Login" }); 
    }


  },
};
</script>